import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationErrorPage} from 'features/deposit/onboarding/pages/DepositApplicationErrorPage';

export const Route = createFileRoute('/_protected/deposit-onboarding/denied')({
  component: DepositApplicationErrorPage,
  validateSearch: (search) => {
    return {
      code: search.code as string | undefined,
    };
  },
});
